import { render, staticRenderFns } from "./RequestWorkTypesListHelp.vue?vue&type=template&id=52d902cb&scoped=true&"
import script from "./RequestWorkTypesListHelp.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypesListHelp.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkTypesListHelp.vue?vue&type=style&index=0&id=52d902cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d902cb",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItemLabel,QList,QItem,QItemSection,QIcon,QBadge,QCheckbox} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItemLabel,QList,QItem,QItemSection,QIcon,QBadge,QCheckbox}, component.options.components || {})
